"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityDateRangeField = exports.entityDateTimeRangeField = exports.entityDateTimeField = exports.entityDateField = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var input_date_1 = require("../components/forms/input-date");
var entity_field_1 = require("./entity-field");
var entityDateField = function (args) {
  var context = args.context,
    label = args.label,
    placeholder = args.placeholder,
    required = args.required,
    name = args.name,
    fieldSet = args.fieldSet,
    endFieldName = args.endFieldName,
    _a = args.includeTime,
    includeTime = _a === void 0 ? false : _a,
    _b = args.maxWidth,
    maxWidth = _b === void 0 ? "140px" : _b,
    validate = args.validate,
    description = args.description;
  var t = context.t;
  var ret = __assign(__assign({}, (0, entity_field_1.entityFieldArgs)(args)), {
    name: name,
    fieldSet: fieldSet,
    maxWidth: maxWidth,
    required: required,
    validate: validate,
    placeholder: placeholder,
    label: t(label || entity_field_1.ENTITY_FIELD_LABELS[name] || (0, lodash_1.startCase)(name)),
    description: t(description),
    render: function (props) {
      return react_1.default.createElement(input_date_1.InputDate, __assign({
        includeTime: includeTime,
        endFieldName: endFieldName
      }, props));
    }
  });
  return ret;
};
exports.entityDateField = entityDateField;
var entityDateTimeField = function (args) {
  return (0, exports.entityDateField)(__assign(__assign({}, args), {
    includeTime: true
  }));
};
exports.entityDateTimeField = entityDateTimeField;
var entityDateTimeRangeField = function (args) {
  return (0, exports.entityDateField)(__assign(__assign({}, args), {
    includeTime: true
  }));
};
exports.entityDateTimeRangeField = entityDateTimeRangeField;
var entityDateRangeField = function (args) {
  return (0, exports.entityDateField)(__assign(__assign({}, args), {
    includeTime: true
  }));
};
exports.entityDateRangeField = entityDateRangeField;